import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export default {
  profileSettings: {
    basicInformation: 'Informações básicas',
    address: 'Endereço',
    citizenshipStatus: 'Status de cidadania',
    investorInformation: 'Informações do investidor',
    riskProfile: 'Perfil de risco',
    saveSuccess: 'Suas alterações foram enviadas com sucesso.',
    saveError: `Não foi possível salvar suas alterações. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com ${FinTronConfig.supportEmail}.`,
  },
  bankLink: {
    title: 'Contas bancárias vinculadas',
    description: `Altere ou atualize sua vinculação bancária usando o Plaid. Selecione uma conta bancária abaixo ou adicione uma nova conta para entrar no Plaid.\n\nGerencie suas contas bancárias vinculadas para ${FinTronConfig.robo.name} e ${FinTronConfig.selfDirected.name} usando o Plaid, uma ferramenta de verificação bancária de terceiros.`,
    account: 'Conta {{ account }}',
    discretionaryDescription: '',
  },
  profileUpdates: {
    title: 'Atualizar informações',
    description: 'Esta atualização será aplicada ao seu perfil.',
    yesUpdate: 'Sim, Atualizar',
  },
  security: {
    title: 'Segurança',
    password: 'Atualizar senha',
    twoFactorAuth: 'Autenticação de dois fatores',
    login: 'Login',
    loginDescription:
      'Enviaremos um e-mail ou SMS com o código de autenticação de dois fatores para cada login.',
    riskProfile: {
      form: {
        question: 'Qual é a sua tolerância ao risco?',
      },
      infograph: {
        title: 'Tolerância ao risco',
        conservative: {
          pre: 'Um',
          bold: 'investidor conservador',
          post: 'valoriza a estabilidade mais do que retornos elevados e prefere menos risco e potencial de queda.',
        },
        moderate: {
          pre: 'Um',
          bold: 'investidor moderado',
          post: 'valoriza uma abordagem equilibrada para crescimento de capital com preservação de capital e aceitação de algum risco.',
        },
        aggressive: {
          pre: 'Um',
          bold: 'investidor arrojado',
          post: 'valoriza retornos elevados mais do que estabilidade e está disposto a aceitar maior risco e maior potencial de queda.',
        },
        footer:
          'Você receberá recomendações de investimento que se alinham com seu perfil de risco escolhido para progredir em direção ao valor total de seu objetivo dentro do prazo desejado.',
      },
      success: {
        message: 'Sua tolerância ao risco foi atualizada com sucesso.',
      },
    },
    changePassword: {
      usernameForm: {
        title: 'Alterar Senha',
        description:
          'Por favor, insira o nome de usuário associado à sua conta e enviaremos um código de redefinição de senha por e-mail.',
        usernamePlaceholder: 'Nome de usuário',
        send: 'Enviar',
        sending: 'Enviando...',
      },
      resetForm: {
        title: 'Nova senha',
        description: 'Por favor, redefina sua senha abaixo.',
        codeLabel: 'Código',
        codePlaceholder: 'Digite o código da senha',
        codeDescription:
          'Enviamos seu código de redefinição de senha por e-mail. Por favor, digite-o acima para continuar com a redefinição de senha.',
        passwordLabel: 'Nova senha',
        passwordPlaceholder: 'Digite a nova senha',
        passwordDescription:
          'Sua senha deve ter no mínimo 8 caracteres e incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial para maior segurança.',
        confirmPasswordLabel: 'Confirme a nova senha',
        confirmPasswordPlaceholder: 'Digite a nova senha',
      },
      success: {
        title: 'Sucesso!',
        description: 'Sua senha foi redefinida.',
      },
    },
  },
  investmentQuestions: {
    title: 'Questões de Investimento',
    notSure: 'Se não tiver certeza, provavelmente não se aplica.',
    experienceLevelQuestion: 'Qual é o seu nível de experiência com investimentos?',
    annualIncomeOptions: {
      _025000: 'Menor ou igual a $25,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _5000011200000: '$500,001-$1,200,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _12000019999999: '$1,200,001-$9,999,999',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Não especificado',
    },
    netWorthOptions: {
      _025000: 'Menor ou igual a $25,000',
      _050000: 'Menor ou igual a $50,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _200001500000: '$200,001-$500,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Não especificado',
    },
    netWorthRangeInfoTitle: 'Encontrando seu Patrimônio Líquido',
  },
  investorInformation: {
    investing: 'Investimento',
    personal: 'Pessoais',
    compliance: 'Compliance',
    investmentExperience: 'Experiência com investimentos',
    investmentObjective: 'Objetivo de investimento',
    investmentTimeHorizon: 'Horizonte de investimento',
    importanceOfCashOnHand: 'Importância de ter dinheiro em mãos',
    marriageStatus: 'Estado civil',
    employmentStatus: 'Status de emprego',
    annualIncome: 'Renda anual',
    netWorth: 'Patrimônio líquido',
  },
};
